import React, { useEffect, useState } from 'react'
import { Alert, Button, Checkbox, Drawer, Form, Input, message, notification, Popconfirm, Tag } from 'antd'
import {
    PlusOutlined,
    SaveOutlined,
    EditOutlined,
    DeleteOutlined,
} from '@ant-design/icons';
import Container from '../../../components/Container'
import Main from '../../../components/Main'
import PageHeader from '../../../components/PageHeader'
import AgoraTable from '../../../components/Table';
import { useAuthUser } from 'react-auth-kit';
import axios from 'axios';

function PaymentTerms() {
    const auth = useAuthUser()
    const [payTermsForm] = Form.useForm();
    const [state, setState] = useState({
        gvPayTermsLoading: false,
        gvPayTerms: [],
        formOpen: false,
        formType: "Add",
        btnSubmitLoading: false,
        btnSubmitResStatus: "",
        btnSubmitResMsg: "",
        btnDeleteLoading: false,
    })
    const handleSetState = (newState) => {
        setState(prevState => ({
            ...prevState,
            ...newState,
        }))
    }
    useEffect(() => {
        getPayTermsPageLoad()
        // eslint-disable-next-line
    }, [])
    const getPayTermsPageLoad = () => {
        handleSetState({ gvPayTermsLoading: true })
        axios.get(`/PayTerms/PageLoad`).then(res => {
            let resData = res.data
            if (resData.Status === "True") {
                handleSetState({
                    gvPayTermsLoading: false,
                    gvPayTerms: resData.Data.gvPayTerms
                })
                return resData.Data
            } else {
                message.error(resData.Message)
            }
        }).catch(error => {
            console.log(error)
            message.error(error.message)
        })
    }
    const handleOnFinishPayTerms = (formData) => {
        handleSetState({ btnSubmitLoading: true })
        if (state.formType === "Add") {
            axios.post(`/PayTerms/Create`, {
                payTermsCode: formData.payTermsCode,
                payTermsDesc: formData.payTermsDesc,
                payTermsDefault: formData.payTermsDefault,
                createdBy: auth().userId,
            }).then(res => {
                let resData = res.data
                if (resData.Status === "True") {
                    handleSetState({
                        formOpen: false,
                        btnSubmitLoading: false
                    });
                    getPayTermsPageLoad();
                    notification.success({
                        message: "Successful",
                        description: resData.Message
                    });
                } else {
                    handleSetState({
                        btnSubmitLoading: false,
                        btnSubmitResStatus: resData.Status,
                        btnSubmitResMsg: resData.Message,
                    });
                }
            }).catch(error => {
                console.log(error);
                message.error(error.message);
            })
        } else if (state.formType === "Edit") {
            axios.post(`/PayTerms/Update`, {
                payTermsId: formData.payTermsId,
                payTermsCode: formData.payTermsCode,
                payTermsDesc: formData.payTermsDesc,
                payTermsDefault: formData.payTermsDefault,
                modifiedBy: auth().userId,
            }).then(res => {
                let resData = res.data
                if (resData.Status === "True") {
                    handleSetState({
                        formOpen: false,
                        btnSubmitLoading: false
                    });
                    getPayTermsPageLoad();
                    notification.success({
                        message: "Successful",
                        description: resData.Message
                    });
                } else {
                    handleSetState({
                        btnSubmitLoading: false,
                        btnSubmitResStatus: resData.Status,
                        btnSubmitResMsg: resData.Message,
                    });
                }
            }).catch(error => {
                console.log(error);
                message.error(error.message);
            })
        }

    }
    const handleOnDeletePayTerms = () => {
        handleSetState({ btnDeleteLoading: true })
        axios.post(`/PayTerms/Delete`, {
            payTermsId: payTermsForm.getFieldValue("payTermsId"),
            modifiedBy: auth().userId,
        }).then(res => {
            let resData = res.data
            if (resData.Status === "True") {
                handleSetState({
                    formOpen: false,
                    btnDeleteLoading: false
                });
                getPayTermsPageLoad();
                notification.success({
                    message: "Successful",
                    description: resData.Message
                });
            } else {
                handleSetState({
                    btnDeleteLoading: false,
                    btnSubmitResStatus: resData.Status,
                    btnSubmitResMsg: resData.Message,
                });
            }
        }).catch(error => {
            console.log(error);
            message.error(error.message);
        })

    }

    const isAllowToManage = () => {
        if (auth().role === "Admin") {
            return true
        }
        return false;
    }

    return (
        <Main listBreadcrumb={[
            { key: "1", title: "Maintenance" },
            { key: "2", title: "Library" },
            { key: "3", title: "Payment Terms" },
        ]}>
            <Container>
                <PageHeader title="Payment Terms" subtitle="List of payment terms details.">
                    {isAllowToManage() &&
                        <Button
                            type="primary"
                            icon={<PlusOutlined />}
                            onClick={() => {
                                payTermsForm.resetFields();
                                handleSetState({
                                    formOpen: true,
                                    formType: "Add",
                                })
                            }}
                        >
                            New Payment Terms
                        </Button>
                    }
                </PageHeader>
                <AgoraTable
                    loading={state.gvPayTermsLoading}
                    dataSource={state.gvPayTerms}
                    rowKey="payTermsId"
                    columns={[
                        {
                            title: 'Payment Terms Code',
                            dataIndex: 'payTermsCode',
                            key: 'payTermsCode',
                            dataType: "text",
                            render: (text, record) => <div className="i-x-space-between">
                                <div className='i-x-left i-y-center'>
                                    {text || "-"}
                                    {record.payTermsDefault && <Tag color="blue" style={{ marginLeft: "10px" }}>Default</Tag>}
                                </div>
                                <div className="i-x-right">
                                    {isAllowToManage() &&
                                        <Button className="table-btn edit" size="small" style={{ marginRight: "10px" }}
                                            onClick={() => {
                                                payTermsForm.setFieldsValue({
                                                    payTermsId: record.payTermsId,
                                                    payTermsCode: record.payTermsCode,
                                                    payTermsDesc: record.payTermsDesc,
                                                    payTermsDefault: record.payTermsDefault,
                                                });
                                                handleSetState({
                                                    formOpen: true,
                                                    formType: "Edit",
                                                })
                                            }}
                                        ><EditOutlined /> Edit</Button>
                                    }
                                </div>
                            </div>,
                        },
                        {
                            title: 'Description',
                            dataIndex: 'payTermsDesc',
                            key: 'payTermsDesc',
                            dataType: "text",
                            render: (text) => text || "-",
                        },
                    ]}
                />
            </Container>
            <Drawer title={`${state.formType} Payment Terms`}
                width={window.innerWidth > 500 ? 500 : window.innerWidth - 80}
                open={state.formOpen}
                extra={
                    <Button type="primary"
                        loading={state.btnSubmitLoading}
                        onClick={() => payTermsForm.submit()}
                        icon={state.formType === "Add" ? <PlusOutlined /> : <SaveOutlined />}
                    >
                        {state.formType === "Add" ? "Add" : "Update"}
                    </Button>
                }
                onClose={() => {
                    payTermsForm.resetFields()
                    handleSetState({
                        formType: "Add",
                        formOpen: false,
                        btnSubmitResStatus: "",
                        btnSubmitResMsg: "",
                    })
                }}
            >
                <div className="i-y-100 i-y-space-between">
                    <Form
                        form={payTermsForm}
                        name="payment-terms-form"
                        layout="vertical"
                        size="middle"
                        requiredMark={false}
                        onFinish={handleOnFinishPayTerms}
                    >
                        {state.btnSubmitResStatus !== ""
                            && <Alert type="error" showIcon style={{ margin: "0px 25px 20px 0px" }}
                                message={state.btnSubmitResMsg}
                            />
                        }
                        <Form.Item hidden={true} name="payTermsId" ></Form.Item>
                        <Form.Item
                            label="Payment Terms Code"
                            name="payTermsCode"
                            tooltip="This is a required field"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please enter payment terms code!',
                                },
                            ]}
                        >
                            <Input placeholder='e.g., Z090' />
                        </Form.Item>
                        <Form.Item
                            label="Description"
                            name="payTermsDesc"
                            tooltip="This is a required field"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please enter payment terms description!',
                                },
                            ]}
                        >
                            <Input placeholder='e.g., 90 Days' />
                        </Form.Item>
                        <Form.Item name="payTermsDefault" valuePropName="checked" noStyle>
                            <Checkbox>Set as Default</Checkbox>
                        </Form.Item>
                    </Form>
                    {state.formType === "Edit"
                        ? <div>
                            <Popconfirm
                                title="Delete payment terms"
                                description="Are you sure to delete this payment terms?"
                                onConfirm={handleOnDeletePayTerms}
                                okText="Yes"
                                okType="danger"
                            >
                                <Button type="primary" danger block loading={state.btnDeleteLoading}
                                    icon={<DeleteOutlined />}
                                >Delete Payment Terms</Button>
                            </Popconfirm>
                        </div>
                        : ""
                    }
                </div>
            </Drawer>
        </Main>
    )
}

export default PaymentTerms